/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderStatus {
    UNPAID = 'unpaid',
    PENDING = 'pending',
    PENDING_PAYMENT = 'pending_payment',
    WAITING_FOR_PAYMENT = 'waiting_for_payment',
    FULLY_PAID = 'fully_paid',
    PARTIALLY_PAID = 'partially_paid',
    SCHEDULED = 'scheduled',
    OVERPAID = 'overpaid',
    CANCELED = 'canceled',
    NO_FEES = 'no_fees',
}
